export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
} as const;

export type HttpStatus = (typeof HTTP_STATUS)[keyof typeof HTTP_STATUS];

export const ENV_KEYS = {
  NODE_ENV: 'NODE_ENV',
  DATABASE_URL: 'DATABASE_URL',
  API_PORT: 'API_PORT',
  API_HOST: 'API_HOST',
  VITE_API_BASE_URL: 'VITE_API_BASE_URL',
} as const;

export type EnvKey = (typeof ENV_KEYS)[keyof typeof ENV_KEYS];

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
} as const;

export const ERROR_CODES = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  CONFLICT: 'CONFLICT',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  RATE_LIMITED: 'RATE_LIMITED',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export const POLICY_TYPE_LABELS: Record<string, string> = {
  MOTOR: 'Motor',
  WC: "Workmen's Comp",
  HEALTH: 'Health',
  GROUP_HEALTH: 'Group Health',
  FIRE: 'Fire',
  BURGLARY: 'Burglary',
  ALL_RISK: 'All Risk',
  DOCTOR_POLICY: 'Doctor Policy',
  NEW: 'New',
  OTHER: 'Other',
};

export const RENEWAL_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pending',
  REMINDED: 'Reminded',
  RENEWED: 'Renewed',
  NOT_RENEWED: 'Not Renewed',
  LAPSED: 'Lapsed',
};

export const URGENCY_LABELS: Record<string, string> = {
  overdue: 'Overdue',
  due7: 'Due this week',
  due30: 'Due this month',
  future: 'Future',
};

export const URGENCY_COLORS: Record<string, string> = {
  overdue: 'red',
  due7: 'amber',
  due30: 'green',
  future: 'gray',
};

export const DEFAULT_SETTINGS = {
  reminderOffsets: [7, 1],
  appLockEnabled: false,
  defaultCountryCode: '+91',
  theme: 'light',
};

export const AUTH = {
  BCRYPT_SALT_ROUNDS: 12,
  REFRESH_TOKEN_COOKIE: 'refresh_token',
} as const;

export const ENQUIRY_STATUS_LABELS: Record<string, string> = {
  OPEN: 'Open',
  CONVERTED: 'Converted',
  DROPPED: 'Dropped',
};

export const ENQUIRY_STATUS_COLORS: Record<string, string> = {
  OPEN: 'blue',
  CONVERTED: 'green',
  DROPPED: 'red',
};

export const DROP_REASON_LABELS: Record<string, string> = {
  CLIENT_NOT_INTERESTED: 'Client Not Interested',
  PREMIUM_TOO_HIGH: 'Premium Too High',
  WENT_WITH_COMPETITOR: 'Went with Competitor',
  CLIENT_UNREACHABLE: 'Client Unreachable',
  DUPLICATE_ENQUIRY: 'Duplicate Enquiry',
  INVALID_DETAILS: 'Wrong / Invalid Details',
  OTHER: 'Other',
};

export const WHATSAPP_TEMPLATE =
  'Dear {{insuredName}}, your {{policyType}} policy{{#vehicleNumber}} ({{vehicleNumber}}){{/vehicleNumber}} expires on {{endDate}}.{{#premiumPrice}} Premium: Rs.{{premiumPrice}}.{{/premiumPrice}}{{#paymentLink}} Pay here: {{paymentLink}}.{{/paymentLink}}{{#renewalNotice}} {{renewalNotice}}{{/renewalNotice}} Please renew on time.';
